export default {
    mvpIntro: '이번 수업의 MVP는 ~',
    buttons: {
        show: '보기',
    },
};
